import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Utility funkce pro slučování Tailwind CSS tříd
 * Kombinuje clsx a tailwind-merge pro správné řešení konfliktů
 */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}
